import { Button as MuiButton, useTheme } from '@mui/material';
import { ReactElement, ReactNode } from 'react';

type Props = {
    children: ReactNode;
    onClick?: () => void;
    variant?: 'text' | 'outlined' | 'contained' | undefined;
    icon?: ReactElement;
    disabled?: boolean;

    /**
     * Should the button be displayed with full width?
     */
    fill?: boolean;

    testId?: string;

    /**
     * In some cases we want the button to be displayed as disabled but
     * still be clickable. In those cases set this to true
     */
    displayAsDisabled?: boolean;
};

const Button = ({ onClick, children, variant, icon, disabled, fill, testId, displayAsDisabled }: Props) => {
    const theme = useTheme();

    return (
        <MuiButton
            variant={variant}
            onClick={() => onClick && onClick()}
            disabled={disabled}
            endIcon={icon}
            sx={{
                background: displayAsDisabled ? theme.palette.grey['400'] : undefined,
                ...{ width: fill ? '100%' : undefined },
            }}
            data-testid={testId}
            data-disabled={!!displayAsDisabled || disabled}>
            {children}
        </MuiButton>
    );
};

export default Button;
